/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import EditableText from 'material/embeds/editabletext/editabletext_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/storycta/storycta_styles';



/* ========== ~~~~~~~~~~ EMBED : STORY CTA ~~~~~~~~~~ ========== */
class StoryCTA extends Component {
    constructor(props) {
        super(props);
        this.prevCharAmount = 0;
        this.characterLimit = 25;
        this.state = { fontSize: 'standard' };
    }
    componentDidMount() {
        // this.validateText(this.props.contentTitle, getElementCSSProperty(document.querySelector('.embededitor .question .text'), 'height'));
        this.validateText({ text: this.props.ctaText, initialValidation: true });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.contentId !== this.props.contentId) this.validateText({ text: this.props.ctaText, initialValidation: true });
    }
    runValidation = text => this.validateText({ text, initialValidation: false });

    validateText = ({ text, initialValidation }) => {
        const trimmedText = text !== null ? text.trim() : '';
        const isValid = this.props.isValid;
        if(trimmedText.length > this.characterLimit || (initialValidation && isValid === null)) return null;
        if (trimmedText.length > 0 && !isValid) {
            this.props.setStoryProperty(this.props.contentId, 'isCTAValid', true)
        } else if ((trimmedText.length > this.characterLimit) && (isValid || isValid === null)) {
            this.props.setStoryProperty(this.props.contentId, 'isCTAValid', false)
        }
    };
    handleSelect = () => {
        if(!this.props.isValid) this.props.setStoryProperty(this.props.contentId, 'isCTAValid', null)
    };
    render() {
        const placeholderText = 'Type your CTA text here';
        return(
            <div className={`storycta ${this.props.classes.storycta} valid-${this.props.isValid}`}>
                    <EditableText
                        key={`${this.props.isEditable ? `editor` : `card`}-story-${this.props.contentId}${this.props.optionId}`}
                        contentId={this.props.contentId}
                        textValue={this.props.ctaText}
                        textType={'storyCTA'}
                        isEditable={this.props.isEditable}
                        isOption={false}
                        optionId={null}
                        placeholder={placeholderText}
                        onKeyUp={this.runValidation}
                        onBlur={this.runValidation}
                        onFocus={this.runValidation}
                        isSelected={true}
                        preventEnter={true}
                        characterLimit={this.characterLimit}
                        validateText={this.runValidation}
                    />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(StoryCTA);
